module.exports = __webpack_public_path__ + "static/media/Sept20-F18.1a7ed9e0.png";